module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "overlay-invite"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "list-side"
  }, [_c('h4', [_vm._v("Invite Matches To Conversation")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "Search Matches...",
      "type": "text"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "list-holder"
  }, _vm._l((_vm.results), function(user) {
    return (_vm.members[user['.key']] == undefined) ? _c('div', {
      class: {
        'list-item': true, 'active': _vm.invitationList.indexOf(user['.key']) !== -1
      },
      on: {
        "click": function($event) {
          _vm.addToList(user['.key'])
        }
      }
    }, [_c('div', {
      staticClass: "image-circle"
    }, [(user.profileimg === 'default') ? _c('img', {
      staticClass: "image-circle",
      attrs: {
        "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
      }
    }) : _c('img', {
      staticClass: "image-circle",
      attrs: {
        "src": user.profileimg
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.firstname + ' ' + user.surname))])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "list-side"
  }, [_c('h4', [_vm._v("Invite someone else:")]), _vm._v(" "), _c('div', {
    staticClass: "form-holder"
  }, [_c('label', [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "modal",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "invite-bottom"
  }, [_c('a', {
    staticClass: "link-simple",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$parent.invite = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "btn bg-three active",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.invite($event)
      }
    }
  }, [_vm._v("Invite")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9d14966c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/conversation/Invite.vue
// module id = 727
// module chunks = 1